import { render } from "./ClustorsListDist.vue?vue&type=template&id=12b3fb95&scoped=true"
import script from "./ClustorsListDist.vue?vue&type=script&lang=js"
export * from "./ClustorsListDist.vue?vue&type=script&lang=js"

import "./ClustorsListDist.vue?vue&type=style&index=0&id=12b3fb95&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b3fb95"]])

export default __exports__